import { createContext } from 'react';
import { TOfferDetailsContext } from './offer-details.types';

export const initialOfferDetailsContext: TOfferDetailsContext = {
    propertyId: 0,
    offerAmount: '',
    comment: '',
    buyers: [],
    buyerAdditionalDetailsInputModel: {
        propertyId: 0,
        propertyToSell: false,
        mortgageRequired: false,
        mortgageAgreementStatus: 'NotYetArranged',
        cashSource: 'Savings',
        moveTimeframe: new Date(),
        timeOnMarket: new Date(),
        saleProgression: 'Pending',
        isInChain: undefined,
        chainTimeFrameAgreed: undefined,
        isPbConnected: false,
        consentedForMAB: undefined,
        media: 'WebSite',
    },
    homeserveOfferDetails: {
        offerId: 0,
        byPost: false,
        byEmail: false,
        bySms: false,
        byPhone: false,
        proceedWithoutExtra: false,
        propertyIsPermanentResidence: false,
        propertyIsRetailCommercialOrBusiness: false,
    },

    setPropertyId: /* istanbul ignore next */ () => ({}),
    setOfferAmount: /* istanbul ignore next */ () => ({}),
    setComment: /* istanbul ignore next */ () => ({}),
    setBuyers: /* istanbul ignore next */ () => ({}),
    setBuyerAdditionalDetailsInputModel: /* instanbul ignore next */ () => ({}),
    setHomeserveOfferDetails: /* istanbul ignore next */ () => ({}),
};

export const OfferDetailsContext = createContext<TOfferDetailsContext>(
    initialOfferDetailsContext
);
